import React from 'react';
import { useTheme } from '@material-ui/core';

import { AppLogoProps } from './AppLogo.interfaces';

function AppLogo({ className, width, height }: AppLogoProps) {
  const { custom } = useTheme();

  return (
    <img
      src={custom.logo.src}
      alt={custom.logo.alt}
      className={className}
      height={height || custom.logo.height}
      width={width || custom.logo.width}
      loading="lazy"
    />
  );
}

export default AppLogo;
